import { Section } from "./Section"
import { Divider, Typography } from "@mui/material"
import { type ReactNode } from "react"

interface ContentSectionProps {
    title: string
    children: ReactNode
    hideTitle?: boolean
}

export const ContentSection = ({ title, children, hideTitle = false }: ContentSectionProps) => {
    return (
        <Section>
            {!hideTitle && (
                <>
                    <Typography variant="h5" component="h2">
                        {title}
                    </Typography>
                    <Divider sx={{ marginBottom: 1 }} />
                </>
            )}
            {children}
        </Section>
    )
}
